{
  "chapel": [
    {
      "id": "nave",
      "u0": 11,
      "u1": 44,
      "v0": -7,
      "v1": 1,
      "eaves": 11.7,
      "ridge": 18.3,
      "entrance": true
    },
    {
      "id": "narrow-choir",
      "u0": 2,
      "u1": 11,
      "v0": -4.6,
      "v1": 1,
      "eaves": 11.7,
      "ridge": 18.3,
      "entrance": false
    }
  ],
  "belfry": {
    "u": 30,
    "v": -3,
    "radius": 0.48,
    "foot": 17,
    "eaves": 19.8,
    "tip": 24
  },
  "ranges": [
    {
      "id": "patershuis",
      "u": 25,
      "v": 5.2,
      "angleDeg": 0,
      "length": 36,
      "width": 8.4,
      "eaves": 11.7,
      "ridge": 18.3,
      "floors": 2,
      "bays": 8,
      "passage": 0,
      "roof": "slate",
      "blindSides": [0],
      "roofGables": {
        "centres": [-12, -6, 0, 6, 12],
        "halfWidth": 0.7,
        "v0": 0.8,
        "v1": 4.2,
        "eaves": 17.15,
        "ridge": 19.1,
        "sill": 15.65,
        "top": 16.65
      }
    },
    {
      "id": "quay-northern-section-4",
      "u": -3.5,
      "v": -7.5,
      "angleDeg": 33.4,
      "length": 14.7,
      "width": 7.3,
      "eaves": 10.6,
      "ridge": 16.5,
      "floors": 2,
      "bays": 3,
      "passage": 0,
      "roof": "slate",
      "blindSides": [1, 3]
    },
    {
      "id": "quay-middle-section-3",
      "u": -20.8,
      "v": -19.1,
      "angleDeg": 33.4,
      "length": 27.5,
      "width": 7.3,
      "eaves": 10.6,
      "ridge": 16.5,
      "floors": 2,
      "bays": 6,
      "passage": 0,
      "roof": "slate",
      "blindSides": [1, 3],
      "roofGables": {
        "centres": [-9, -3, 3, 9],
        "halfWidth": 0.7,
        "v0": 0.8,
        "v1": 3.65,
        "eaves": 15.3,
        "ridge": 17.2,
        "sill": 13.8,
        "top": 14.8
      }
    },
    {
      "id": "quay-southern-section-2",
      "u": -43.4,
      "v": -34.1,
      "angleDeg": 33.4,
      "length": 27,
      "width": 5.2,
      "eaves": 8.6,
      "ridge": 13.8,
      "floors": 2,
      "bays": 5,
      "passage": 0,
      "roof": "slate",
      "blindSides": [1]
    },
    {
      "id": "southern-brewery-range-1",
      "u": -28,
      "v": -39.5,
      "angleDeg": -3.1,
      "length": 56,
      "width": 6.4,
      "eaves": 8.0,
      "ridge": 13.0,
      "floors": 2,
      "bays": 12,
      "passage": 0,
      "roof": "tile",
      "blindSides": [1]
    }
  ],
  "floors": [
    {
      "ring": [
        [-7.13, -14.5],
        [-6.18, -13.88],
        [10.04, -7.2],
        [38.48, -8.18],
        [37.3, -9.18],
        [37.27, -9.39],
        [37.45, -9.51],
        [44.06, -8.19],
        [44.19, -8.05],
        [46.19, -1.06],
        [48.95, 7.21],
        [52.38, 5.99],
        [44.83, -12.89],
        [29.35, -30.0],
        [24.48, -33.86],
        [13.93, -43.3],
        [1.95, -52.79],
        [-15.31, -49.47],
        [-15.46, -48.96],
        [-15.94, -48.35],
        [-16.76, -47.97],
        [-35.96, -44.53],
        [-36.9, -44.61],
        [-37.76, -45.15],
        [-47.35, -43.31],
        [0.07, -45.19],
        [20.14, -28.14],
        [29.12, -16.54],
        [29.02, -16.35],
        [28.81, -16.36],
        [25.86, -18.86],
        [0.01, -43.71],
        [0.33, -37.83],
        [0.18, -37.63],
        [-38.97, -35.5],
        [-27.88, -29.16],
        [-13.67, -19.01],
        [-7.2, -14.75]
      ],
      "height": 0.025,
      "garden": false
    },
    {
      "ring": [
        [-11.0, -20.0],
        [8.0, -12.0],
        [25.0, -12.0],
        [16.0, -18.0],
        [-5.0, -36.0],
        [-31.0, -31.0]
      ],
      "height": 0.04,
      "garden": true
    }
  ],
  "walls": [],
  "note": "The medieval island and buildings follow the relationships recorded by Meischke (1975), chapter 4 pp. 114–121 and figure 180: chapel with choir narrowed on the southern side, parallel patershuis, three canal-range sections and southern range next to the Begijnhof. Thin chapel walls have no external buttresses. Southern section 2 was not excavated; choir attachments and internal partitions are partly uncertain. The old images establish a roof belfry. Rectangular component masses, precise registration, dimensions, heights, roof joints, roof gables, doors, windows, court soil and access remain fitted estimates, not measured 1538 elevations or a literal excavation survey. The 1532 public passage and restored Begijnensloot stay outside the institution. Burials are documented south of the chapel; their exact cemetery boundary is unresolved. No 1581 portal, 1590 outer quay wing, 1634–35 paired orphanage courts, modern Schuttersgalerij or 1544–45 Oudemannenhuis is backdated."
}
